import {Component, Input, NgZone, ViewChild} from '@angular/core';
import {AbstractNgModelComponent} from '../ng-model.component';
import {IonSegment} from '@ionic/angular';

@Component({template: ''})
// @ts-ignore
export abstract class IonChipBaseComponent extends AbstractNgModelComponent<string> implements IonSegment {

  @ViewChild('ionChip', {static: false}) ionChipElement;

  @Input() color?: any;
  @Input() mode: 'ios' | 'md' = 'md';
  @Input() outline?: boolean = false;

  protected el: HTMLElement;
  protected z: NgZone;

}
